import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../context/UserContext";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const Logout = () => {
  const navigate = useNavigate();
  const { dispatch } = useUserContext();
  const [signingOut, setSigningOut] = useState(false);

  const performLogout = () => {
    setSigningOut(true);
    dispatch({ type: "CLEAR_USER" });
    localStorage.removeItem("shipNode");
    navigate("/");
  };

  const footer = (
    <div className="flex justify-end gap-2">
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => navigate(-1)}
        disabled={signingOut}
      />
      <Button
        label="Sign Out"
        icon={signingOut ? "pi pi-spin pi-spinner" : "pi pi-sign-out"}
        className="p-button-danger"
        onClick={performLogout}
        disabled={signingOut}
      />
    </div>
  );

  return (
    <Dialog
      header="Sign Out"
      visible
      style={{ width: "400px", minWidth: "320px" }}
      onHide={() => !signingOut && navigate(-1)}
      footer={footer}
      modal
      closable={!signingOut}
    >
      <div className="flex align-items-center gap-3 py-3">
        <i className="pi pi-sign-out text-red-500" style={{ fontSize: "2rem" }} />
        <span className="text-lg">Are you sure you want to sign out?</span>
      </div>
    </Dialog>
  );
};

export default Logout;
